import {
  BookmarkSimpleIcon,
  CheckCircleIcon,
  CheckIcon,
  EyeSlashIcon,
  FastForwardIcon,
  SmileyXEyesIcon,
  TimerIcon,
  WarningOctagonIcon,
  XCircleIcon,
  XIcon,
} from '@phosphor-icons/react';

export default function QuestionJourneyPill({
  showAttemptAnalysis,
  item,
  selectedQuestion,
  handleQuestionClick,
  correctFirstIncorrectLater,
}) {
  return (
    <div
      className={`w-10 h-10 z-2 border rounded-lg flex items-center justify-center relative cursor-pointer
        ${selectedQuestion === item?.questionNumber ? 'bg-[var(--q3-accent-light)] border-[var(--q3-accent-normal)]' : correctFirstIncorrectLater ? 'border-[var(--q3-danger-normal)]' : 'border-[var(--q3-stroke-light)] bg-[var(--q3-surface-default)] '}
      `}
      onClick={() => handleQuestionClick(item)}
    >
      <div className="absolute bottom-0 translate-y-1/2">
        {!showAttemptAnalysis ? (
          item.isCorrect ? (
            <CheckIcon
              size={16}
              className="text-[var(--q3-green-normal)]"
              weight="bold"
              stroke="var(--q3-surface-default)"
            />
          ) : item.isSkipped ? (
            <FastForwardIcon size={16} className="text-[var(--q3-neutral-light)]" weight="fill" />
          ) : (!item.isCorrect && (item?.selectedOptions?.length || item?.inputValue?.trim())) ||
            ((item.status === 'answered' || item.status === 'answeredReview') && !item.isCorrect) ? (
            <XIcon size={16} className="text-[var(--q3-danger-normal)]" weight="bold" />
          ) : item?.status === 'notVisited' ? (
            <EyeSlashIcon size={16} className="text-[text-[var(--q3-neutral-light)]]" />
          ) : item?.status === 'notAnswered' || item?.status === 'markedReview' ? (
            <WarningOctagonIcon size={16} className="text-[text-[var(--q3-neutral-light)]]" />
          ) : (
            <></>
          )
        ) : item?.attemptOverview === 'perfect' ? (
          <CheckCircleIcon size={16} className="text-[var(--q3-green-normal)]" />
        ) : item?.attemptOverview === 'wasted' ? (
          <XCircleIcon size={16} className="text-[var(--q3-danger-normal)]" />
        ) : item?.attemptOverview === 'overtime' ? (
          <TimerIcon size={16} className="text-[var(--q3-orange-normal)]" />
        ) : item?.attemptOverview === 'confused' ? (
          <SmileyXEyesIcon size={16} className="text-[var(--q3-neutral-light)]" />
        ) : (
          <></>
        )}
      </div>
      <div className="absolute top-0 right-0 -translate-y-1/5 translate-x-1 bg-[var(--q3-surface-default)]">
        {item.isMarkedReview || item?.status === 'markedReview' || item?.status === 'answeredReview' ? (
          <BookmarkSimpleIcon className="text-[var(--q3-accent-normal)]" weight="fill" />
        ) : item.isUnmarkedReview ? (
          <BookmarkSimpleIcon className="text-[var(--q3-accent-normal)]" weight="bold" />
        ) : (
          <></>
        )}
      </div>
      <div className="absolute top-0 left-1 -translate-y-1/5 bg-[var(--q3-surface-default)]">
        {item.timeVisited > 1 && (
          <div className="w-5 h-5 flex items-center justify-center rounded-full border border-[var(--q3-stroke-light)] bg-[var(--q3-surface-default)] absolute top-0 -translate-x-1/2 -translate-y-1/2 text-xs text-[var(--q3-accent-normal)]">
            {item.timeVisited}
          </div>
        )}
      </div>
      <p className="text-base font-normal">{item.questionNumber}</p>
    </div>
  );
}
